import React, { Fragment, useEffect, useState } from "react";
import { useFormik } from "formik";

import createCompanyFormValidationSchema from "../../ValidationSchema/createCompanyFormValidationSchema";
import { apiWrapWithErrorWithData } from "../../utils/apiWrapper";
import {
  getAllCompany,
  createCompanyService,
  getCompany,
  updateCompany,
} from "../../Redux/Actions/company";
import DataTable from "../../utils/dataTable";
import CustomModal from "../../utils/customModal";
import { useSelector } from "react-redux";
import { toastMessage } from "../../utils/toast";
import { clearSession } from "../../utils/initiate";

const initialCreateFormValues = {
  companyName: "",
  companyEmail: "",
  password: "",
  contactPersonName: "",
  contactPersonPhone: "",
  contactPersonEmail: "",
  companyRegistrationDocument: [],
  companyRegistrationExpiryDate: "",
  companyRegistrationVatNumber: "",
  isActive:false
};

const formType = [
  { name: "companyName", type: "text", label: "Company name", isLoop: false, labelData: [] },
  { name: "companyEmail", type: "email", label: "Company email", isLoop: false, labelData: [] },
  { name: "password", type: "password", label: "Password", isLoop: false, labelData: [] },
  { name: "contactPersonName", type: "text", label: "Contact Person name", isLoop: false, labelData: [] },
  { name: "contactPersonPhone", type: "number", label: "Contact person phone", isLoop: false, labelData: [] },
  { name: "contactPersonEmail", type: "email", label: "Contact person email", isLoop: false, labelData: [] },
  { name: "isActive", type: "select", label: "Status", isLoop: false, labelData: [] },
  {
    name: "", type: "", label: "Company registration document", isLoop: true, labelData: [
      { name: "companyRegistrationDocument", type: "file", label: "Document" },
      { name: "companyRegistrationExpiryDate", type: "date", label: "Trade Licence Expiry Date" },
      { name: "companyRegistrationVatNumber", type: "text", label: "VAT Registarton No" },
    ]
  }
];
const options = [
  { value: false, label: 'InActive' },
  { value: true, label: 'Active' }
]
const Companies = ({ history }) => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so we add 1
  const day = String(now.getDate()).padStart(2, '0');
  const minDate = `${year}-${month}-${day}`;
  const userData = useSelector(({ User }) => User.data);
  const [currentPage, setCurrentPage] = useState(0);
  const [companiesData, setCompaniesData] = useState({
    totalCount: 0,
    companies: [],
  });
  const [createCompany, setCreateCompany] = useState({
    isShow: false,
    isLoading: false,
  });
  const [editCompany, setEditCompany] = useState({
    editedData: null,
    id: 0,
  });
  const [formInitialValueState, setFormInitialValState] = useState({
    ...initialCreateFormValues,
  });

  useEffect(() => {
    getAllCompaiesApi(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (editCompany.id) {
      getCompanyByIdApi(editCompany.id);
    }
  }, [editCompany.id]);

  const getCompanyByIdApi = async (id) => {
    try {
      const res = await apiWrapWithErrorWithData(getCompany(id));
      const response = res.data;

      if (response.data) {
        const rawDate = response.data?.companyRegistrationExpiryDate;
        let FormattedDate = null;
        if (rawDate) {
          const date = new Date(rawDate);
          const year = String(date.getFullYear()).padStart(4, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');

          FormattedDate = `${year}-${month}-${day}`;
        } else {
          console.log("Invalid or missing date");
        }
        const companyData = {
          companyName: response.data?.companyName,
          companyEmail: "demo@email.com",
          password: "password",
          contactPersonName: response.data?.contactPersonName,
          contactPersonPhone: response.data?.contactPersonPhone,
          contactPersonEmail: response.data?.contactPersonEmail,
          companyRegistrationDocument: null,
          companyRegistrationExpiryDate: FormattedDate,
          companyRegistrationVatNumber: response.data?.companyRegistrationVatNumber,
          isActive: response.data?.isActive
        };
        setFormInitialValState({ ...companyData });
        setEditCompany((preState) => ({ ...preState, data: companyData }));
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        toastMessage("error", "Session expired. Please login again.");
        clearSession(null, history);
        if (history && typeof history.push === 'function') {
          history.push('/login');
        }
      } else {
        console.log("getAllJobsApi", error);
        toastMessage("error", "Unable to fetch company details");
      }
      toastMessage("error", "Unable to fetch company details");
      console.log("getCompanyByIdApi", error);
    }
  };

  const getAllCompaiesApi = async (page) => {
    try {
      const res = await apiWrapWithErrorWithData(getAllCompany(page));
      const response = res?.data;
      console.log("getAllCompaiesApi response", res);
      if (response?.data) {
        setCompaniesData({
          totalCount: response?.data?.totalCount,
          companies: response?.data?.companies,
        });
      }
      if(!res){
        toastMessage("error", "Session expired. Please login again.");
        history.push('/login');
      }
    } catch (error) {
      console.log("getAllCompaiesApi error", error);
      if (error?.response?.status === 401) {
        toastMessage("error", "Session expired. Please login again.");
        if (history && typeof history.push === 'function') {
          history.push('/login');
        }
      } else {
        toastMessage("error", "Unable to fetch company details");
        console.log("getAllCompaiesApi", error);
      }
      console.log("getAllCompaiesApi", error);
    }
  };

  const columns = [
    {
      Header: "Id",
      accessor: "id",
    },
    {
      Header: "Company name",
      accessor: "companyName",
    },
    {
      Header: "Company email",
      accessor: "companyEmail",
    },
    {
      Header: "Contact person name",
      accessor: "contactPersonName",
    },
    {
      Header: "Contact person email",
      accessor: "contactPersonEmail",
    },
    {
      Header: "Action",
      accessor: "ContactPersonEmail",
      Cell: ({ cell }) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            {cell.row.original.id && (
              <button
                className="json-button btn btn-sm btn-primary"
                onClick={() => {
                  setEditCompany((preState) => ({
                    ...preState,
                    id: cell.row.original.id,
                  }));
                  setCreateCompany((preState) => ({
                    ...preState,
                    isShow: true,
                  }));
                }}
              >
                {"Edit"}
              </button>
            )}
          </div>
          <div>
            {cell.row.original.id && (
              <button
                className="json-button btn btn-sm btn-primary"
                onClick={() => history.push(`/company-info/${cell.row.original.id}`)}
              >
                {"Veiw"}
              </button>
            )}
          </div>
        </div>
      ),
    }
  ];

  const formik = useFormik({
    initialValues: formInitialValueState,
    enableReinitialize: true,
    // validateOnChange: false,
    validateOnBlur: true,
    validationSchema: createCompanyFormValidationSchema(!!editCompany.id),
    onSubmit: (values) => {
      editCompany.id ? updateCompanyApi(values) : createCompanyApi(values);
      // handleClose();
      // formik.resetForm();
      // setEditCompany((preState) => ({
      //   ...preState,
      //   id: 0,
      // }));
      // setFormInitialValState({ ...initialCreateFormValues });
    },
  });

  const createCompanyApi = async (payload) => {
    setCreateCompany((preState) => ({ ...preState, isLoading: true }));
    const formData = new FormData();
    formData.append("companyName", payload.companyName)
    formData.append("companyEmail", payload.companyEmail)
    formData.append("password", payload.password)
    formData.append("contactPersonName", payload.contactPersonName)
    formData.append("contactPersonPhone", payload.contactPersonPhone)
    formData.append("contactPersonEmail", payload.contactPersonEmail)
    formData.append("companyRegistrationExpiryDate", payload.companyRegistrationExpiryDate)
    formData.append("companyRegistrationVatNumber", payload.companyRegistrationVatNumber)
    formData.append("affiliateAgentId", userData.UserId)
    formData.append("isActive", payload.isActive)
    payload.companyRegistrationDocument.forEach((file, fileIndex) => {
      formData.append(`companyRegistrationDocument`, file);
    });
    try {
      const res = await createCompanyService(formData);
      const response = res.data;
      getAllCompaiesApi(0);
      setCreateCompany((preState) => ({
        ...preState,
        isLoading: false,
        isShow: false,
      }));
      if (res.status === 200) {
        formik.resetForm();
        setEditCompany((preState) => ({
          ...preState,
          id: 0,
        }));
        setFormInitialValState({ ...initialCreateFormValues });
      }
      toastMessage("success", response?.message || "Company has been created successfully");
    } catch (error) {
      toastMessage("error", error.response.data.message);
      setCreateCompany((preState) => ({ ...preState, isLoading: false }));
    }
  };

  const updateCompanyApi = async (payload) => {
    setCreateCompany((preState) => ({ ...preState, isLoading: true }));
    const formData = new FormData();
    formData.append("companyName", payload.companyName)
    formData.append("contactPersonName", payload.contactPersonName)
    formData.append("contactPersonPhone", payload.contactPersonPhone)
    formData.append("contactPersonEmail", payload.contactPersonEmail)
    formData.append("companyRegistrationExpiryDate", payload.companyRegistrationExpiryDate)
    formData.append("companyRegistrationVatNumber", payload.companyRegistrationVatNumber)
    formData.append("isActive", payload.isActive)
    if(payload.companyRegistrationDocument){
    payload.companyRegistrationDocument.forEach((file, fileIndex) => {
      formData.append(`companyRegistrationDocument`, file);
    });
  }
    try {
      const res = await apiWrapWithErrorWithData(
        updateCompany({ id: editCompany.id, payload: formData })
      );
      const response = res.data;
      getAllCompaiesApi(0);
      setCreateCompany((preState) => ({
        ...preState,
        isLoading: false,
        isShow: false,
      }));
      formik.resetForm();
      setEditCompany((preState) => ({
        ...preState,
        id: 0,
      }));
      setFormInitialValState({ ...initialCreateFormValues });
      toastMessage("success", response?.message || "Company has been updated successfully");
    } catch (error) {
      toastMessage("error", "Unable to update the company");
      setCreateCompany((preState) => ({ ...preState, isLoading: false }));
    }
  };

  const handleFileChange = (event, name) => {
    const files = event.target.files;
    const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf', 'application/x-zip-compressed', 'application/x-compressed'];
    const filteredFiles = Array.from(files).filter(file => allowedFormats.includes(file.type));
    if (filteredFiles.length !== files.length) {
      toastMessage("error", 'Invalid file format. Please select only jpg, jpeg, png, pdf, or zip files.');
      event.target.value = '';
      return;
    }
    // formik.setFieldValue(name, e.target.files[0])
    formik.setFieldValue(name, filteredFiles)
  };
  const body = (
    <form autoComplete="off" noValidate>
      {formType.map(({ name, type, label, isLoop, labelData }) => {
        const shouldDisplayField = !editCompany.id || !["companyEmail", "password"].includes(name);
        if (!shouldDisplayField) return null;
        return (
          <>
            {isLoop ? (
              <label
                className="form-label col-md-10 col-sm-2"
                style={{ marginTop: "5px", fontWeight: 'bold' }}
              >
                {label}
              </label>
            ) : (
              <label
                className="form-label col-md-10 col-sm-2"
                style={{ marginTop: "5px" }}
              >
                {label}
              </label>
            )}
            {isLoop ? (
              // <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                {labelData.map(({ name, type, label }) => (
                  <div>
                    <label
                      className="form-label col-md-10 col-sm-2"
                      style={{ marginTop: "1px" }}
                    >
                      {label}
                    </label>
                    {type === 'file' ? (
                      <input
                        className="p-1 form-control col-md-4 col-sm-2"
                        name={name}
                        type={type} multiple
                        onChange={(e) => handleFileChange(e, name)}
                      />
                    ) : (
                      <div>
                        {type === 'date' ? (
                          <input className="p-1 form-control col-md-4 col-sm-2" type={type} name={name} min={minDate} onChange={formik.handleChange}
                            value={formik.values[name]}></input>
                        ) : (
                          <input
                            className="p-1 form-control col-md-4 col-sm-2"
                            name={name}
                            type={type}
                            onChange={formik.handleChange}
                            value={formik.values[name]}
                            placeholder={type === 'file' ? `Choose ${label.toLowerCase()}` : `Please enter ${label.toLowerCase()}`}
                          />
                        )}
                      </div>
                    )}
                    {formik.touched[name] && formik.errors[name] ? (
                      <div style={{ color: "red" }}>{formik.errors[name]}</div>
                    ) : null}
                    {/* {formik.errors[name] ? <div style={{ color: 'red' }}>{formik.errors[name]}</div> : null} */}
                  </div>
                ))}
              </div>
            ) : (
              <div>
                {type === 'select' ? (
                  <select
                    name={name}
                    onChange={formik.handleChange}
                    value={formik.values[name]}
                    className="p-1 form-select col-md-4 col-sm-2"
                  >
                    {options.map((option, index) => (
                      <option key={index} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    className="p-1 form-control col-md-4 col-sm-2"
                    name={name}
                    type={type}
                    autoComplete={"new-" + type}
                    onChange={formik.handleChange}
                    value={formik.values[name]}
                    placeholder={`Please enter ${label.toLowerCase()}`}
                  />)}
                {formik.touched[name] && formik.errors[name] ? (
                  <div style={{ color: "red" }}>{formik.errors[name]}</div>
                ) : null}
                {/* {formik.errors[name] ? <div style={{ color: 'red' }}>{formik.errors[name]}</div> : null} */}
              </div>
            )
            } </>
        );
      })}
    </form>
  );

  const handleClose = () => {
    formik.resetForm();
    setCreateCompany((preState) => ({
      ...preState,
      isShow: false,
      isLoading: false,
    }));
    setFormInitialValState({ ...initialCreateFormValues });
    setEditCompany((preState) => ({
      ...preState,
      id: 0,
    }));
  };

  return (
    <Fragment>
      <div className="d-flex justify-content-end">
        <button
          className="btn btn-primary m-3"
          onClick={() =>
            setCreateCompany((preState) => ({ ...preState, isShow: true }))
          }
        >
          Create company
        </button>
      </div>
      <DataTable
        columns={columns}
        currentPage={currentPage}
        data={companiesData.companies}
        setCurrentPage={setCurrentPage}
        totalCount={companiesData.totalCount}
      />
      <CustomModal
        body={body}
        handleClose={handleClose}
        show={createCompany.isShow}
        title={editCompany.id ? "Update company" : "Create company"}
        isLoading={createCompany.isLoading}
        handleSubmit={formik.handleSubmit}
      />
    </Fragment>
  );
};

export default Companies;
